import { Component } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { PushService } from '../push.service';
import { PwaInstallService } from '../pwa-install.service';

const DISMISS_KEY = 'pwa-push-dismissed';

/**
 * Bandeau invitant à activer les notifications push — fidèle à la maquette.
 * Ne s'affiche que sur mobile, si le push est réellement disponible
 * (`push.isSupported` requiert un service worker actif → intégration uniquement),
 * que la permission n'a pas encore été décidée, et que l'utilisateur ne l'a pas
 * déjà fermé.
 */
@Component({
  selector: 'pwa-push-prompt',
  templateUrl: './pwa-push-prompt.component.html',
  styleUrls: ['./pwa-push-prompt.component.scss'],
  standalone: false,
})
export class PwaPushPromptComponent {
  private readonly closed$ = new BehaviorSubject<boolean>(false);

  readonly show$: Observable<boolean> = this.closed$.pipe(
    map(
      closed =>
        this.install.isMobile &&
        this.push.isSupported &&
        this.push.permission === 'default' &&
        !this.isDismissed() &&
        !closed,
    ),
  );

  readonly busy$: Observable<boolean> = this.push.busy$;

  constructor(
    private readonly push: PushService,
    private readonly install: PwaInstallService,
  ) {}

  async enable(): Promise<void> {
    const enabled = await this.push.enable();
    // On ne masque le bandeau que si l'activation a abouti ou que le navigateur
    // a tranché (refus). Sinon (geste perdu, échec réseau…), on laisse retenter.
    if (enabled || this.push.permission === 'denied') {
      this.closed$.next(true);
    }
  }

  dismiss(): void {
    localStorage.setItem(DISMISS_KEY, '1');
    this.closed$.next(true);
  }

  private isDismissed(): boolean {
    return localStorage.getItem(DISMISS_KEY) === '1';
  }
}
